import {
  GET_LIMITS_FAILURE,
  GET_LIMITS_REQUEST,
  GET_LIMITS_SUCCESS,
  RESET_STATUS_CONFIG_STATE,
  STATUS_CONFIG_LOADER_START,
  STATUS_CONFIG_LOADER_STOP,
  UPDATE_LIMITS_REQUEST,
} from "./types";

const initialState = {
  loading: false,
  error: null,
  limits: null,
};

const data360LiveStatusConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case STATUS_CONFIG_LOADER_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case STATUS_CONFIG_LOADER_STOP:
      return {
        ...state,
        loading: false,
      };

    // Get Limits
    case GET_LIMITS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_LIMITS_SUCCESS:
      return {
        ...state,
        loading: false,
        limits: action.payload,
        error: null,
      };
    case GET_LIMITS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Reset State
    case RESET_STATUS_CONFIG_STATE:
      return initialState;

    case UPDATE_LIMITS_REQUEST:
      return { ...state, loading: true };

    default:
      return state;
  }
};

export default data360LiveStatusConfigReducer;
